window.CtrlTabs = (()=>{
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   **/
  var I18N = {
    es: {
      button: {
        next: 'Continuar',
        skip: 'Saltar introducción'
      }
    },
    en: {
      button: {
        next: 'Continue',
        skip: 'Skip`introduction'
      }
    }
  };
  var BUTTON_NETX = "<a class='btn btn-primary btn-switch-tab'>__TEXT__</a>";
  var BUTTON_SKIP = "<a class='btn btn-warning btn-skip-intro ml-3 font-bold'>__TEXT__</a>";
  var CONTAINER = ".tab-navigator";
  var GLOBAL_PERCENTAGE = "#global-percentage";

  /**
   * ------------------------------------------------------------------------
   * Methods
   * ------------------------------------------------------------------------
   **/
  // Draw 'continue' button (BUTTON_NEXT)
  printButtonNext = ()=>{
    let final_btn = BUTTON_NETX.replace('__TEXT__', I18N[$("html").attr('lang')].button.next);
    $(CONTAINER).each((k,v)=>{
      $(v).html(final_btn);
    });
  };

  // Draw 'skip' button (BUTTON_SKIP)
  printButtonSkip = ()=>{
    let final_btn = BUTTON_SKIP.replace('__TEXT__', I18N[$("html").attr('lang')].button.skip);
    $(CONTAINER).each((k,v)=>{
      if (parseFloat($($(v).data('validator-skip')).html().replace('%', '')) > 0){
        $(v).append(final_btn);
      }
    });
  };

  // Switch tab when pressing continue button (BUTTON_NEXT)
  switchTab = ()=>{
    $(document).on('click', '.btn-switch-tab', (e)=>{
      let next = $( $(e.currentTarget).closest(CONTAINER).data('tab') + ' .active').parent().next('li')
      if (next.length) {
        next.find('a').trigger('click');
      } else {
        $( $(e.currentTarget).closest(CONTAINER).data('content') ).addClass('d-none');
        $(e.currentTarget).closest(CONTAINER).addClass('d-none');
        $( $(e.currentTarget).closest(CONTAINER).data('content-show') ).removeClass('d-none');
      }
    });
  };

  // Skip introduction
  skipIntroduction = () => {
    $(document).on('click', '.btn-skip-intro', (e) => {
      $( $(e.currentTarget).closest(CONTAINER).data('content') ).addClass('d-none');
      $(e.currentTarget).closest(CONTAINER).addClass('d-none');
      $( $(e.currentTarget).closest(CONTAINER).data('content-show') ).removeClass('d-none');
    });
  };

  document.addEventListener('turbolinks:load', ()=>{
    printButtonNext();
    printButtonSkip();
    switchTab();
    skipIntroduction();
  });
})();